import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API, useAuth } from "../App";
import { ShoppingBag, Package, MapPin, Clock, IndianRupee, X } from "lucide-react";

const STATUS_PILL = {
  placed: "bg-sun/40 text-ink",
  confirmed: "bg-sky/15 text-sky",
  packed: "bg-brand/15 text-brand",
  shipped: "bg-brand/15 text-brand",
  delivered: "bg-leaf/40 text-ink",
  cancelled: "bg-surface-muted text-ink-soft",
};

export default function MyOrders() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/orders/mine`).then(r => setItems(r.data.items || [])); }, []);
  if (!user) return null;

  return (
    <div className="space-y-6" data-testid="my-orders-page">
      <header>
        <div className="text-xs uppercase tracking-[0.2em] text-brand font-bold inline-flex items-center gap-1"><ShoppingBag className="w-4 h-4"/>My orders</div>
        <h1 className="font-heading text-3xl font-extrabold mt-1">Your purchases</h1>
        <p className="text-ink-soft text-sm">Track every order from accepted to delivered.</p>
      </header>
      {items.length === 0 ? (
        <div className="bg-surface border border-dashed border-line rounded-3xl p-10 text-center text-ink-soft">
          No orders yet. <Link to="/app/store" className="text-brand font-bold">Browse the pet store</Link>.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map(o => (
            <article key={o.order_id} data-testid={`order-${o.order_id}`} className="bg-surface border border-line rounded-3xl p-4 shadow-soft">
              <div className="flex items-center justify-between gap-2 flex-wrap text-sm">
                <div className="inline-flex items-center gap-1.5"><Package className="w-4 h-4 text-brand"/><span className="font-mono text-xs text-ink-soft">{o.order_id.slice(-10)}</span></div>
                <span className={`text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5 ${STATUS_PILL[o.status]}`}>{o.status}</span>
                <span className="font-heading font-extrabold inline-flex items-center"><IndianRupee className="w-3.5 h-3.5"/>{o.total || 0}</span>
              </div>
              <div className="text-xs text-ink-soft inline-flex items-center gap-1.5 mt-2"><Clock className="w-3 h-3"/>{new Date(o.created_at).toLocaleString()} · <MapPin className="w-3 h-3"/>{o.delivery_address}</div>
              <div className="mt-3 text-xs space-y-0.5">
                {(o.items || []).map((it, i) => (<div key={i} className="flex justify-between"><span>{it.name} × {it.quantity || 1}</span><span className="font-bold">₹{(Number(it.price) || 0) * (Number(it.quantity) || 1)}</span></div>))}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
